import { render, staticRenderFns } from "./StripeMobileRedirect.vue?vue&type=template&id=973064b6"
import script from "./StripeMobileRedirect.vue?vue&type=script&lang=js"
export * from "./StripeMobileRedirect.vue?vue&type=script&lang=js"
import style0 from "./StripeMobileRedirect.vue?vue&type=style&index=0&id=973064b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports